<template>
  <div class="account-btn"
       :class="[providerName, !!provider ? 'active':'']"
       @click="!provider ? $emit('connect', providerName) : ''">
    <font-awesome-icon class="text-xl" :icon="['fab', providerName]"/>
    <template v-if="!!provider">
      <span>{{ textCapitalize(provider.name || provider.provider) }}</span>
      <v-popover offset="11"
                 open-group="social-disconnect-popover"
                 popoverClass="social-disconnect-popover">
        <IconCross class="w-3 h-3 cursor-pointer"/>
        <template slot="popover">
          <div class="col-span-2">
            <div class="text-lg font-bold text-text"
                 v-html="$t('disconnectQuestion',{providerName:textCapitalize(providerName)})"></div>
          </div>
          <BaseButton size="sm" theme="red" v-close-popover @click="apply">
            {{ $t('apply') }}
          </BaseButton>
          <BaseButton size="sm" theme="white-bordered" v-close-popover>
            {{ $t('cancel') }}
          </BaseButton>
        </template>
      </v-popover>

    </template>
  </div>
</template>

<script>
import IconCross from "@/components/icons/IconCross";
import BaseButton from "@/components/UI/BaseButton";
import ArchiveBtn from "@/components/UI/ArchiveBtn";

export default {
  name: "UserConnectedAccountsItem",
  components: {ArchiveBtn, BaseButton, IconCross},
  props: ['provider', 'providerName'],
  methods: {
    apply() {
      this.$emit('disconnect', this.providerName);
    },
    textCapitalize(text) {
      return text.charAt(0).toUpperCase() + text.slice(1);
    }
  },
  i18n: {
    messages: {
      en: {
        disconnectQuestion: 'Disconnect {providerName} account<br> from your profile?',
        apply: 'Disconnect',
        cancel: 'Cancel'
      },
      ru: {
        disconnectQuestion: 'Отвязать аккаунт {providerName}<br> от вашего профиля?',
        apply: 'Отвязать',
        cancel: 'Отмена'
      }
    }
  }
}
</script>

<style lang="scss">
.account-btn {
  @apply flex items-center text-sm p-2 rounded transition-all duration-200;

  span {
    @apply mx-3;
  }

  &.apple {
    color: black;
  }

  &.google {
    color: #e94334;
  }

  &:not(.active) {
    @apply opacity-50 cursor-pointer;
    &:hover {
      @apply opacity-100;
    }
  }

  &.active {
    @apply text-white;

    &.apple {
      background: black;
    }

    &.google {
      background: #e94334;
    }
  }
}

.tooltip.popover.social-disconnect-popover {
  &:before {
    position: fixed;
    content: '';
  }

  &:focus {
    @apply outline-none;
  }

  .popover-inner {
    @apply p-4 bg-block shadow-primaryBlock rounded;
    width: 250px;
    z-index: 2;

    > div {
      @apply grid grid-cols-2 col-gap-4 row-gap-4;
    }
  }

  &[x-placement^="top"] {
    .popover-arrow {
      border-width: .8rem .8rem 0 .8rem;
      bottom: -.8rem;
    }
  }

  &[x-placement^="bottom"] {
    .popover-arrow {
      top: -.8rem;
      border-width: 0 .8rem .8rem .8rem;
    }
  }

  .popover-arrow {
    @apply border-block;
    z-index: 1;
    filter: drop-shadow(0px 4px 8px rgba(86, 114, 155, 0.6));
  }
}
</style>